import { ArrowLeftIcon } from "@radix-ui/react-icons";
import React from "react";
import Header from "../../../components/Header";
import AccountSettings from "../../../components/AccountSettings";
import Banner from "../../../components/Banner";
import Bottombar from "../../../components/Bottombar";
import Topbar from "../../../components/Topbar";
import { PAYMENTS } from "../../../constants/settingsStrings.js";
import { Link } from "react-router-dom";

function Success() {
  return (
    <div className="overflow-hidden screen dark:bg-white dark:text-black dark:h-screen">
      <Topbar />
      <div className="sm:hidden flex space-x-[100px]  mt-7 ">
        <Link to="/settings/paymentnextstep">
          {" "}
          <ArrowLeftIcon color="#545454" className="ml-4 w-[17px] h-[17px]" />
        </Link>

        <h3 className="dark:text-black font-bold text-[20px]">
          Payment Method
        </h3>
      </div>

      <div className="mt-5 sm:hidden">
        <div class="flex justify-between ">
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Details
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center pt-1">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Payment
            </div>
          </div>
          <div class="w-1/3 text-center">
            <div class="bg-[#42BA96] rounded-full h-[12px] w-[12px] inline-flex items-center justify-center ">
              <span class="text-sm font-bold text-white">✓</span>
            </div>
            <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
              Confirm
            </div>
            {/* <div className="absolute border-2 w-[119px] border-[#6200EE] top-[129px] left-[70px] mn-2"></div>
            <div className="absolute border-2 w-[117px] border-[#6200EE]  top-[129px] left-[202px] mn-2"></div> */}
          </div>
        </div>
      </div>
      <div className="hidden  md:block">
        <Header />
      </div>

      <div className="flex">
        <div className="hidden md:block">
          <AccountSettings active={PAYMENTS} />
        </div>
        <div className="w-[925px]  sm:w-[64vw] mt-2 h-[500px] rounded-[25px] sm:shadow-xl  sm:mx-10 my-4">
          <div className="hidden md:block">
            {" "}
            <Banner />
          </div>

          <div className="hidden md:block mt-3">
            <div className="grid place-content-center ">
              <div className=" flex ">
                <div class=" flex space-x-10 ">
                  <div class="w-1/3 text-center mr-3">
                    <div class="bg-[#42BA96] rounded-full relative h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Details
                    </div>{" "}
                  </div>
                  <div class="w-1/3 text-center">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Payment
                    </div>
                  </div>
                  <div class="w-1/3 text-center ml-3">
                    <div class="bg-[#42BA96] rounded-full h-[25px] w-[25px] inline-flex items-center justify-center">
                      <span class="text-sm font-bold text-white w-[3px] h-[3px] mb-4 mr-3">
                        ✓
                      </span>
                    </div>
                    <div class="mt-2 font-medium text-sm text-gray-500 dark:text-black">
                      Confirm
                    </div>
                    {/* <div className="absolute border-2 w-[78px] border-[#EEEEEE] top-[358px] left-[735px] mn-2"></div>

                    <div className="absolute border-2 w-[70px] border-[#EEEEEE] top-[358px] left-[836px] mn-2"></div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center mb-4  ">
          <div class="bg-[#119957] rounded-full sm:h-16 h-[150px] w-[150px] sm:w-16  mt-3  items-center justify-center  top-[90px] sm:top-0    grid place-content-center relative">
            <img
              src={require("../../../assets/img/tick.png")}
              alt=""
              className="sm:h-10  h-20"
            />
          </div>
          </div>
       

          <div className=" flex flex-col items-center justify-center mt-24 sm:mt-0 ">
  <h3 className="sm:text-[16px] text-[34px] font-[400]">
    Success!
  </h3>
  <h3 className="text-[#202124] text-[14px] mt-3 font-[400] mb-2 sm:left-0 top-[550px] sm:top-0 bottom-[10px] left-0 sm:bottom-[30px] sm:h-[40px] rounded-[27.34px]">
    Thank you for your Subscription
  </h3>
  <Link to="/settings">
    <button className="bg-[#0049F5] font-[800] text-white w-[315px] sm:w-[200px] sm:p-2 p-3 rounded-[25px] mt-28 sm:mt-0   text-[19px]  mb-2">
      Done
    </button>
  </Link>
</div>

         
        </div>
      </div>
      <h3 className=" md:block hidden dark:text-black absolute text-[12px] text-[#878787] font-[900] mt-9  sm:left-[50%]  bottom-[70px] left-[40%]">
          Terms and conditions{" "}
      </h3>
      <Bottombar activeBar={'settings'} />
    </div>
  );
}

export default Success;
